import React, { useEffect, useState } from "react";
import "./DelinquencyReport.scss";
import { useSelector, useDispatch } from "react-redux";
import LoanTable from "../../../components/LoanTable/LoanTable";
import { Box } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import LoanReportsTable from "../../../components/LoanReportsTable/LoanReportsTable";

const DelinquencyReport = ({startDate, endDate, duration, isCustomFilter}) => {
  let user = useSelector((state) => state.login);
  const [reportData, setReportData] = useState([]);
  
  useEffect(()=> {
    getReportData();
  },[duration, isCustomFilter]);

  const getReportData = async() => {
    try {
      const response = await commonRunQuery(253, `${startDate}/${endDate}`);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const reportsArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
        setReportData(reportsArray);
        console.log("getReportData==========",reportsArray);
      } else {
        setReportData([]);
      }
      console.log("getReportData---------------",response);
    } catch (error) {
      console.log("getReportData_error==========",error);
    }
  }

  const columns = [
    {
      label: 'Loan ID',
      getValue: (row) => row.li?.LoanID ?? ''
    },
    {
      label: 'Borrower Name',
      getValue: (row) => row.record?.BorrowerName?.toString().trim() ? row.record?.BorrowerName : "-"
    },
    {
      label: 'Loan Amount',
      getValue: (row) => row.li?.LoanAmount ?? '',
      align: 'right',
      amount: true
    },
    {
      label: 'Due Date',
      getValue: (row) => row.li?.DueDate ?? ''
    },
    {
      label: 'Days Past Due',
      getValue: (row) => row.record?.DaysPastDue ?? ''
    },
    {
      label: 'Amount Due',
      getValue: (row) => row.record?.AmountDue ?? '',
      align: 'right',
      amount: true
    }
  ];

  return (
    <Box>
        <LoanReportsTable 
          data={reportData} 
          columns={columns} 
          title="Loan Delinquency Report" 
          formatRow={(row) => [
            row.li?.LoanID,
            row.record?.BorrowerName,
            row.li?.LoanAmount,
            row.li?.DueDate,
            row.record?.DaysPastDue,
            row.record?.AmountDue
          ]} 
          author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
        />
    </Box>
  )
}

export default DelinquencyReport;
